import { useLocation } from "react-router-dom";
import Router from "./routes";
import "./App.css";
import "./styles/loader.css";
import "react-toastify/dist/ReactToastify.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { useEffect } from "react";
import * as AgGrid from "ag-grid-enterprise";
import { queryClient } from "./queries/client";
import { QueryClientProvider } from "react-query";
import ScrollToTop from "./shared/ScrollToTop";
import { ToastContainer } from "react-toastify";
import * as amplitude from "@amplitude/analytics-browser";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getAuthStore, useAuthStore } from "./store/useAuthStore";
import {
  AmplitudeInit,
  handleClickForTracking,
  handlePageLoadForTracking,
} from "./analytics";
import { initGA, logPageView } from "./GAanalytics";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./pages/auth/MIcrosoftAuthPage";

const agGridLicenseKey = process.env.REACT_APP_AG_LICENSE_KEY || "";
AgGrid.LicenseManager.setLicenseKey(agGridLicenseKey);

function App() {
  // AmplitudeInit();
  const location = useLocation();
  const msalInstance = new PublicClientApplication(msalConfig);

  useEffect(() => {
    // if (process.env.REACT_APP_GA4) {
    //   initGA(process.env.REACT_APP_GA4 || "");
    //   logPageView(window.location.pathname + window.location.search);
    // }
    handlePageLoadForTracking("location");
  }, [location]);

  const { isAuthenticated, email, name } = useAuthStore();

  useEffect(() => {
    const ampApi: string = process.env.REACT_APP_AMPLITUDE_KEY || "";
    if (isAuthenticated && email) {
      amplitude.init(ampApi, {
        defaultTracking: {
          sessions: true,
          formInteractions: false,
          pageViews: false,
        },
      });

      amplitude.setUserId(email);
      amplitude.identify(new amplitude.Identify().set("fullName", name || ""));
    }
  }, [isAuthenticated, email]);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <ScrollToTop />
          <div
            onClick={(e) => {
              handleClickForTracking(e);
            }}
          >
            <Router />
          </div>{" "}
          <ToastContainer position="bottom-right" autoClose={2000} />
        </QueryClientProvider>
      </MsalProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
